// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__Pm9y+","sub_container":"WordGameLayout_sub_container__4oZRl"};